class EscapeManager {
  escapeFunctionList = new Map();

  add(key, callback) {
    this.escapeFunctionList.set(key, callback);
  }

  remove(key) {
    this.escapeFunctionList.delete(key);
  }

  fireEscapeKey(event) {
    if (event.key === 'Escape' && this.escapeFunctionList.size) {
      const lastKey = Array.from(this.escapeFunctionList.keys()).pop();
      const lastCallback = this.escapeFunctionList.get(lastKey);
      if (lastCallback) {
        lastCallback();
        this.remove(lastKey);
      }
    }
  }

  constructor() {
    window.addEventListener('keyup', this.fireEscapeKey.bind(this));
  }
}
export default new EscapeManager();
